<template>
	<v-file-input
		ref="fileInput"
		:value="value"
		:dense="dense"
		:hide-details="hideDetails"
		:label="label"
		:outlined="outlined"
		:placeholder="placeholder"
		v-bind="$attrs"
		v-on="$listeners"
	/>
</template>

<script>
export default {
	name: 'KFileInput',
	model: {
		prop: 'value',
		event: 'change'
	},
	props: {
		value: [File, Array],
		dense: Boolean,
		hideDetails:  {
			type: [Boolean, String],
			default: 'auto'
		},
		label: String,
		outlined: Boolean,
		placeholder: String
	},
	mounted() {
		this.sync_decorative_focus_targets()
	},
	updated() {
		this.sync_decorative_focus_targets()
	},
	methods: {
		sync_decorative_focus_targets() {
			const root = this.$refs.fileInput?.$el
			if (!root) return

			const prepend_button = root.querySelector('.v-input__icon--prepend > button')
			const file_input = root.querySelector('input[type="file"]')

			// Keep one clear keyboard target for file inputs so this control behaves
			// like a single action instead of exposing both the trigger button and
			// the hidden native file input in the tab order.
			if (prepend_button) {
				prepend_button.setAttribute('tabindex', '0')
				prepend_button.setAttribute('type', 'button')
				prepend_button.removeAttribute('aria-hidden')
				prepend_button.removeAttribute('focusable')
				if (!prepend_button.getAttribute('aria-label')) {
					prepend_button.setAttribute('aria-label', this.label || this.placeholder || 'Select a file')
				}
			}

			if (file_input) {
				file_input.setAttribute('tabindex', '-1')
				file_input.setAttribute('aria-hidden', 'true')
				file_input.setAttribute('focusable', 'false')
			}
		}
	}
};
</script>
